import React from 'react';

export default function     Encabezado(props){

    return <h4>
        {props?.Icon} {props?.Nombre}<br />
    </h4>
}